import { withStyles } from '@material-ui/core';
import LockStatus from './LockStatus';
import styles from './styles';

export default withStyles(styles)(LockStatus);
